import { defineStore } from "pinia";
import { addSeconds } from "date-fns";
import type VideoPlayer from "~/components/Organisms/VideoPlayer.vue";

// ライブ、アーカイブビデオ再生時のステートを保存しておくStore
// レイアウトが複雑な場合位は値の受け渡しが大変なのでpiniaを利用する
export const useVideoStateStore = defineStore("VideoStateStore", () => {
  // 未ログイン警告
  const gotoLogin = ref<boolean>(false); // 警告

  // 警告、エラー
  const warning = ref<boolean>(false); // 警告
  const warningMessage = ref<string>(""); // 警告メッセージ

  const error = ref<boolean>(true); // エラー
  const errorMessage = ref<string>(""); // エラーメッセージ

  const setWarning = (value: string) => {
    warning.value = true;
    warningMessage.value = value;
  };
  const clearWarning = () => {
    warning.value = false;
    warningMessage.value = "";
  };
  const setError = (value: string) => {
    error.value = true;
    errorMessage.value = value;
  };
  const clearError = () => {
    error.value = false;
    errorMessage.value = "";
  };

  // ビデオプレイヤー
  const videoPlayer = ref<typeof VideoPlayer | null>(null);

  const setVideoPlayer = (value: typeof VideoPlayer | null) => {
    videoPlayer.value = value;
  };

  // 時間
  const startDateTime = ref<Date>(); // 開始時間
  const currentTime = ref<number>(0); // 再生時間
  const currentDateTime = ref<Date>(); // 開始時間＋再生時間

  const setStartDateTime = (value: Date) => {
    startDateTime.value = value;
    setCurrentDateTime();
  };

  // VideoPlayerからのsetCurrentTimeは表示のみを変更する
  const setCurrentTimeFromVideoPlayer = (value: number) => {
    currentTime.value = value;
    setCurrentDateTime();
  };

  // CurrentTimeをVideoPlayerにセットする
  const setCurrentTimeToVideoPlayer = (value: number) => {
    if (videoPlayer.value) {
      videoPlayer.value.setCurrentTime(value, true);
    }
  };

  const setCurrentDateTime = () => {
    if (startDateTime.value) {
      currentDateTime.value = addSeconds(startDateTime.value, currentTime.value);
    }
  };

  const reset = () => {
    setVideoPlayer(null);
    warning.value = false;
    error.value = false;
    currentTime.value = 0;
    currentDateTime.value = new Date();
    startDateTime.value = new Date();
  };

  return {
    gotoLogin,
    warning,
    warningMessage,
    error,
    errorMessage,
    videoPlayer, // for test
    startDateTime,
    currentTime,
    currentDateTime,
    setWarning,
    clearWarning,
    setError,
    clearError,
    setVideoPlayer,
    setStartDateTime,
    setCurrentTimeFromVideoPlayer,
    setCurrentTimeToVideoPlayer,
    reset,
  };
});
